module.exports = __webpack_public_path__ + "img/ASAN_06.f91da82e.png";